import { useEffect } from "react"
import useDynamicFavicon from "@/components/Favicon/hooks/useDynamicFavicon"

const FaviconManager = () => {
  useDynamicFavicon()

  // opcional: future-proof (evita warnings si el hook cambia internamente)
  useEffect(() => {
    return () => {}
  }, [])

  return null
}

export default FaviconManager